import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Modal from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Theme from '@amzn/meridian/theme';
import { colorForest400 } from '@amzn/meridian-tokens/base/color';
import checkCircleFilledTokens from '@amzn/meridian-tokens/base/icon/check-circle-filled';
import closeMediumTokens from '@amzn/meridian-tokens/base/icon/close-medium';
import { css } from '@emotion/css';
import React from 'react';

const checkedGreen = css({
  color: colorForest400,
});

interface ISuccessModalProps {
  handleClose: () => void;
  showModal: boolean;
  heading?: string;
  description: string;
}

const SuccessModal = ({ handleClose, showModal, heading, description }: ISuccessModalProps) => {
  return (
    <Modal bodySpacingInset="none" open={showModal} width="30rem">
      <Row width="100%" alignmentHorizontal="end">
        <Button type="icon" onClick={handleClose}>
          <Icon tokens={closeMediumTokens}></Icon>
        </Button>
      </Row>
      <Column width="100%" spacingInset="300 600 600 600" alignmentHorizontal="center">
        {heading && <Text type="h600">{heading}</Text>}
        <Theme palette="blue" mode="light">
          <Icon tokens={checkCircleFilledTokens} className={checkedGreen} />
        </Theme>
        <Text alignment="center" type="b400">
          {description}
        </Text>
      </Column>
    </Modal>
  );
};

export default SuccessModal;
